
export default {
  name: 'icon-status-schedule',
};
